import BowserUltralight from 'bowser-ultralight';

let parsedUA: BowserUltralight.Parser.Parser | null;
const parseUserAgent = () => {
	if (parsedUA === undefined) {
		const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
		parsedUA = userAgent ? BowserUltralight.getParser(userAgent) : null;
	}
	return parsedUA;
};

const getBrowserNameAndVersion = () => {
	const browser = parseUserAgent();
	if (browser) {
		return browser.getBrowser();
	}
	return { name: '', version: '' };
};

const isGreaterOrEqualToMinimumVersion = (bowserVersion: string, minimumVersion: number) => {
	const parts = bowserVersion.split('.');
	const part1 = parts[0];
	const part2 = parts[1];
	let version;
	if (part2) {
		version = `${part1}.${part2}`;
	} else {
		version = part1;
	}

	return Number(version) >= minimumVersion;
};

export const getBrowser = () => getBrowserNameAndVersion();

// @deprecated IE11 support has been discontinued https://hello.atlassian.net/browse/PC-9526
export const isIE11 = () => {
	const { name, version } = getBrowserNameAndVersion();

	return name === 'Internet Explorer' && version === '11.0';
};

export const isEdge = (minimumVersion = 0) => {
	const { name, version } = getBrowserNameAndVersion();

	return (
		name === 'Microsoft Edge' && isGreaterOrEqualToMinimumVersion(version || '', minimumVersion)
	);
};

export const isChrome = (minimumVersion = 0) => {
	const { name, version } = getBrowserNameAndVersion();

	return name === 'Chrome' && isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

export const isSafari = (minimumVersion = 0) => {
	const { name, version } = getBrowserNameAndVersion();

	return name === 'Safari' && isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

export const isFirefox = (minimumVersion = 0): boolean => {
	const { name, version } = getBrowserNameAndVersion();

	return name === 'Firefox' && isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
